import React from 'react';
import { Link } from 'react-router-dom';
import MercedesAxor from '../resources/MercedesAxor.jpg';

function Hero() {
  return (
    <div
      className="relative h-screen bg-cover bg-center bg-no-repeat flex items-center"
      style={{ backgroundImage: `url(${MercedesAxor})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 pt-32 w-full">
        <h1 className="text-white text-5xl md:text-7xl font-bold leading-tight animate__animated animate__fadeInDown">
          Stavebné materiály
          <br />
          <span className="text-red-500">&amp; Doprava</span>
        </h1>
        <p className="text-gray-200 text-lg md:text-xl mt-6 max-w-xl animate__animated animate__fadeInDown animate__delay-1s">
          Kvalitné kamenivo, piesky a štrky s vlastnou dopravou. Spoľahnite sa na nás pri každom stavebnom projekte.
        </p>
        <div className="mt-10 flex gap-4 flex-wrap animate__animated animate__fadeInUp animate__delay-1s">
          <Link
            to="/ponuka"
            className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded font-semibold text-lg transition-colors duration-200"
          >
            Naša ponuka
          </Link>
          <Link
            to="/contact"
            className="border-2 border-white text-white hover:bg-white hover:text-black px-8 py-4 rounded font-semibold text-lg transition-colors duration-200"
          >
            Kontaktujte nás
          </Link>
        </div>
      </div>
      <button
        onClick={() => document.getElementById('why-us').scrollIntoView({ behavior: 'smooth' })}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white  cursor-pointer bg-transparent border-none p-0"
        aria-label="Scroll down"
      >
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
    </div>
  );
}

export default Hero;
